export default "__VITE_ASSET__qz1Spav$__"